import React from 'react';
import { FiInbox } from 'react-icons/fi';

export default function EmptyState({ icon: Icon = FiInbox, title, description, action, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className}`}>
      <div className="w-16 h-16 rounded-2xl bg-surface-2 flex items-center justify-center mb-4">
        <Icon size={28} className="text-content-muted" />
      </div>
      {title && <h3 className="text-base font-semibold text-content mb-1">{title}</h3>}
      {description && <p className="text-sm text-content-secondary max-w-sm mb-4">{description}</p>}
      {action}
    </div>
  );
}
